import StorageUtils from './storage';
import FirestoreUtils from './firestore';
import moment from 'moment';
import AuthService from '@/services/AuthService';
import BlockService from '@/services/BlockService';
import UsersDataService from "@/services/UsersDataService";
import isEmpty from "is-empty";

export default {
    normalize(data) {
        data.status = data.online === 1 ? "online" : "off";

        let search = data.search;
        let searchType = data.searchType;
        data.search = [];
        data.searchType = [];

        if (search.indexOf(",") > -1) {
            let _sParts = search.split(",");
            _sParts.forEach((_s) => {
                data.search.push(parseInt(_s));
            });
        } else {
            data.search.push(parseInt(search));
        }

        if (searchType.indexOf(",") > -1) {
            let _stParts = searchType.split(",");
            _stParts.forEach((_st) => {
                data.searchType.push(parseInt(_st));
            });
        } else {
            data.searchType.push(parseInt(searchType));
        }

        return data;
    },

    normalizeUpdates(data) {
        data.status = data.online === 1 ? "online" : "off";

        let search = data.search;
        let searchType = data.searchType;
        data.search = [];
        data.searchType = [];

        if (search.indexOf(",") > -1) {
            let _sParts = search.split(",");
            _sParts.forEach((_s) => {
                data.search.push(parseInt(_s));
            });
        } else {
            data.search.push(parseInt(search));
        }

        if (searchType.indexOf(",") > -1) {
            let _stParts = searchType.split(",");
            _stParts.forEach((_st) => {
                data.searchType.push(parseInt(_st));
            });
        } else {
            data.searchType.push(parseInt(searchType));
        }

        data.updatesData = JSON.parse(data.data);

        return data;
    },

    formatDate (date) {
        return moment(new Date(date)).format('lll');
    },

    getInitials (fullName) {
        if (isEmpty(fullName))
            return '';

        return fullName.split(' ').map(name => name[0]).join('').toUpperCase();
    },

    getGenderImg(sex) {
        let image;
        switch (sex) {
            case 0:
                image = "blank.png";
                break;
            case 1:
                image = "man.png";
                break;
            case 2:
                image = "woman.png";
                break;
            default:
                image = "blank.png";
        }

        return require('@/assets/images/'+image);
    },

    getSubscribeImg(subscribe) {
        let image;
        switch (subscribe) {
            case 0:
                image = "subscribe_0.png";
                break;
            case 1:
                image = "subscribe_1.png";
                break;
            case 2:
                image = "subscribe_2.png";
                break;
            default:
                image = "blank.png";
        }

        return require('@/assets/images/'+image);
    },

    getCountryName(countriesISO, countryCode, locale) {
        return countriesISO.getName(countryCode, locale);
    },

    getGenderSearchImg(search) {
        if (search.length > 1) {
            return require('@/assets/images/man_woman.png')
        }
        else
            return require('@/assets/images/'+(search.includes(1)?'man':'woman')+'.png')
    },

    getAge (birthday) { // birthday is a date
        if (birthday == null || birthday === "")
            return "";

        return moment().diff(moment(birthday.replace('-', ''), 'YYYYMMDD'), 'years');
    },

    getAgeDiff (birthday1, birthday2) {
      const age1 = parseInt(this.getAge(birthday1));
      const age2 = parseInt(this.getAge(birthday2));

      if (isEmpty(age1) || isEmpty(age2))
          return "-";

      if (age1 < age2) {
          return age2 - age1;
      }
      else {
          return age1 - age2;
      }
    },

    isPhoneValid (phone) {
        window.console.warn(`isPhoneValid ${phone} not implemented`);
        return true;
    },

    validMedia (userId, media) {
        return FirestoreUtils.validUserMedia(userId, media);
    },

    removePremium (userId) {
        return FirestoreUtils.removePremium(userId);
    },

    deleteSubscription (userId, subscription) {
        return FirestoreUtils.deleteSubscription(userId, subscription);
    },

    cancelSubscription (subscription) {
        return FirestoreUtils.cancelSubscription(subscription);
    },

    cancelUserPack (userId, pack) {
        return FirestoreUtils.cancelUserPack(userId, pack);
    },

    savePublicInfo (userId, data) {
        return FirestoreUtils.updateUserPublic(userId, data);
    },

    savePrivateInfo (userId, data) {
        return FirestoreUtils.updateUserPrivate(userId, data);
    },

    deleteToken (userId, token) {
        return FirestoreUtils.deleteToken(userId, token);
    },

    updateAlerts (userId, alertId) {
        return FirestoreUtils.updateAlerts(userId, alertId);
    },

    async deleteOldMediaBeforeReupload (userId, media) {
        try {
            window.console.log("transformAndUploadMedia");
            // storage delete previous file
            await StorageUtils.deleteUserMedia(userId, media.mediaId);
            window.console.log("deleteUserMedia success");
            if (!media.isValid) {
                await StorageUtils.deleteUserMedia(userId, media.mediaId + '.origin');
                window.console.log("deleteUserMedia .origin success");
                // firestore update isValid
                await FirestoreUtils.validUserMedia(userId, media);
                window.console.log("validUserMedia success");
            }
            return Promise.resolve();
        }
        catch (error) {
            window.console.error(error);
            return Promise.reject(error);
        }
    },

    async deleteOldMediaCroppedBeforeReupload (userId, media) {
        try {
            window.console.log("transformAndUploadMedia");
            // storage delete previous file
            await StorageUtils.deleteUserMedia(userId, 'crop_' + media.mediaId);
            window.console.log("deleteUserMedia success");
            return Promise.resolve();
        }
        catch (error) {
            window.console.error(error);
            return Promise.reject(error);
        }
    },

    setMediaAsMain (userId, media) {
        return FirestoreUtils.setMainMedia(userId, media);
    },

    deleteMedia (userId, media) {
        return FirestoreUtils.deleteUserMedia(userId, media);
    },

    saveDescription (userId, description) {
        return FirestoreUtils.updateUserPublic(userId, {description: description});
    },

    saveInterests (userId, interests) {
        return FirestoreUtils.updateUserPublic(userId, {interests: interests});
    },

    saveLifeStyle (userId, lifeStyle) {
        return FirestoreUtils.updateUserPublic(userId, {lifeStyle: lifeStyle});
    },

    checkedUser (userId, params) {
        return UsersDataService.checkUser(userId, params);
    },

    async deleteUser (userId, adminId) {
        try {
            const responseActiveSubscription = await UsersDataService.hasActiveSubscription(userId);
            const { result } = responseActiveSubscription.data;
            if (isEmpty(result) || result === true) {
                return Promise.reject(new Error("subscription"));
            }
            await AuthService.deleteUser(userId, adminId);
        }
        catch (error) {
            window.console.error("deleteUser failed... ", error);
            return Promise.reject(new Error(error.message));
        }
    },

    async disableUser (userId, adminId) {
        try {
            const responseActiveSubscription = await UsersDataService.hasActiveSubscription(userId);
            const { result } = responseActiveSubscription.data;
            if (isEmpty(result) || result === true) {
                return Promise.reject(new Error("subscription"));
            }
            await AuthService.disableUser(userId, adminId);
            return FirestoreUtils.updateUserPrivate(userId, {disabled: true});
        }
        catch (error) {
            window.console.error("disableUser failed... ", error);
            return Promise.reject(new Error(error.message));
        }
    },

    async enableUser (userId, adminId) {
        try {
            await AuthService.enableUser(userId, adminId);
            return FirestoreUtils.updateUserPrivate(userId, {disabled: false});
        }
        catch (error) {
            window.console.error("enableUser failed... ", error);
            return Promise.reject(new Error(error.message));
        }
    },

    async blockPhone (phone, adminId) {
        try {
            const isBlocked = await BlockService.isPhoneBlocked(phone);
            if (isBlocked)
                return Promise.reject(new Error('Phone already blocked'));

            return FirestoreUtils.blockPhone(phone, adminId);
        }
        catch (error) {
            window.console.error("blockPhone failed... ", error);
            return Promise.reject(new Error(error.message));
        }
    },
};
